module.exports = __webpack_public_path__ + "static/media/44452957_2199888493419663_4681893482288119808_o.c9f77d5f.jpg";